import { Link } from "react-router-dom";
import { PhoneCall, MapPin, Mail } from "lucide-react";
import { serviceCategories } from "@/data/services";
import { site } from "@/data/site";

import { img } from "@/data/images";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Doctors", to: "/doctors" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
  { label: "Appointment", to: "/appointment" },
];

const legal = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Medical Disclaimer", to: "/medical-disclaimer" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-100 text-foreground-800">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={img.logo}
                alt="AV Clinic"
                className="h-11 w-auto"
                style={{ maxHeight: 44 }}
              />
              <span className="leading-tight">
                <span className="block font-heading text-lg font-semibold text-primary-950">AV Clinic</span>
                <span className="block text-[11px] text-foreground-500">Skin · Urology · Andrology</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              A specialist clinic in Krishnagiri offering Dermatology, Hair &amp; Trichology, Aesthetic
              Dermatology, Urology and Andrology care — delivered with accuracy, compassion and a
              patient-first approach.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-primary-950 mb-4">
              Specialties
            </h4>
            <ul className="space-y-2.5 text-sm">
              {serviceCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/services/${cat.slug}`}
                    className="text-foreground-600 hover:text-secondary-700 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-primary-950 mb-4">
              Quick Links
            </h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-foreground-600 hover:text-secondary-700 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-sm font-bold uppercase tracking-wider text-primary-950 mt-6 mb-3">
              Legal
            </h4>
            <ul className="space-y-2.5 text-sm">
              {legal.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-foreground-600 hover:text-secondary-700 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-primary-950 mb-4">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-5 h-5 shrink-0 text-secondary-600" />
                <span className="text-foreground-600 leading-relaxed">{site.address}</span>
              </li>
              <li className="flex gap-3 items-start">
                <PhoneCall className="w-5 h-5 shrink-0 text-secondary-600" />
                <span className="text-foreground-600">
                  {site.phones.map((p) => (
                    <a
                      key={p.number}
                      href={`tel:${p.number}`}
                      className="block hover:text-secondary-700 transition-colors whitespace-nowrap"
                    >
                      {p.display}
                    </a>
                  ))}
                </span>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="w-5 h-5 shrink-0 text-secondary-600" />
                <a
                  href={`mailto:${site.email}`}
                  className="text-foreground-600 hover:text-secondary-700 transition-colors break-all"
                >
                  {site.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-primary-200">
        <div className="mx-auto max-w-container px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p className="text-center sm:text-left">
            © 2026 AV Clinic. All Rights Reserved.
          </p>
          <p className="text-center sm:text-right">
            Specialist Medical Care · Krishnagiri, Tamil Nadu
          </p>
        </div>
      </div>
    </footer>
  );
}